(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tuanty-bfcm-early-buy"] && !Shopify.designMode) return;
  try {
    (() => {
    const preservePreview = () => {
      const explicitId = new URLSearchParams(window.location.search).get('preview_theme_id');
      const theme = window.Shopify && window.Shopify.theme;
      const draftId = theme && String(theme.role).toLowerCase() !== 'main' ? String(theme.id) : '';
      const previewId = /^\d+$/.test(explicitId || '') ? explicitId : draftId;
      if (!/^\d+$/.test(previewId)) return;
      document.querySelectorAll('[data-tu-bfcm-product-link]').forEach((link) => {
        const url = new URL(link.getAttribute('href'), window.location.origin);
        url.searchParams.set('preview_theme_id', previewId);
        link.href = url.pathname + url.search + url.hash;
      });
    };
    preservePreview();
    document.addEventListener('DOMContentLoaded', preservePreview, { once: true });
    document.addEventListener('shopify:section:load', preservePreview);
  })();
  } catch(e) { console.error(e); }
})();

})();
